import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../datasource/api";
import CryptoJS from "crypto-js";
import axios from "axios";
import routesName from "../../constants/routesName";
import { AsyncAccessTokenDecoder1 } from "../../utils/accessTokenDecoder";

export const getOwnershipType = createAsyncThunk(
  "get/ownership-type",
  async (_: any, { rejectWithValue }) => {
    try {
      const response = await API.get("ownership-type");
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

export const getProductType = createAsyncThunk(
  "get/product-type",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get("Products/products");
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

export const getProductServiceType = createAsyncThunk(
  "get/product-serivce",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get("Products/services");
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

export const getSpecialisationType = createAsyncThunk(
  "get/getspecialisationsType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get("Specialisation/specialisations");
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

export const getDevicesList = createAsyncThunk(
  "get/devices-list",
  async (_, { rejectWithValue }) => {
    try {
      const response = await API.get("Devices/devices");
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

export const addHospital = createAsyncThunk(
  "post/hospital",
  async (data: any | undefined, { rejectWithValue }) => {
    try {
      const responseHospital = await API.post(
        `Hospital/hospitals/Add?isSaveAsDraft=${data.isSaveAsDraft}`,
        data?.dispatchData?.dispatchData
      );

      const { finalData } = data?.dispatchData;

      if (finalData) {
        const AES_KEY = '2dc41670ehdjurl1jdhu76yhtf6d48bb';
        const AES_IV = '1208987836506021';
        const encryptString = (plainText: string) => {
          const keyUtf8 = CryptoJS.enc.Utf8.parse(AES_KEY || "");
          const ivUtf8 = CryptoJS.enc.Utf8.parse(AES_IV || "");
          const encrypted = CryptoJS.AES.encrypt(plainText, keyUtf8, { iv: ivUtf8 });
          return encrypted.toString();
        };
        const dataPost = {
          email: finalData?.hospitalAdminManagementEmail ?? "",
          password: finalData?.userPassword ? encryptString(finalData?.userPassword ?? null) : null,
          firstName: finalData?.hospitalAdminManagementName ?? "",
          lastName: finalData?.hospitalAdminManagementName?.pop?.() || "-",
          phoneNumber: finalData?.hospitalAdminManagementMobileNumber ?? "",
          isPasswordChangeOnLogin: finalData?.isPasswordChangeOnLogin,
          department: "",
          hospitalid: responseHospital.data?.data,
          degree: "",
          gender: "male",
        };


        try {
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('newlogin')} `, // Add token here
          };
          const url: string = process.env.REACT_APP_MA_REGISTER_URL as string;

          const response = await axios.post(url, dataPost, { headers });
          console.log("Response:", response.data);

          const MAPROLEURL = process.env.REACT_APP_MA_MAP_USER_ROLE_URL || ''
          axios.post(MAPROLEURL, { userId: response?.data?.userId, hospitalid: responseHospital.data?.data }, { headers })

          const params = {
            email: dataPost?.email,
            ModuleId: 2,
          };
          const data2 = [
            'MAHospitalManagement'
          ];
          const addRoleURl = process.env.REACT_APP_MA_ROLE_URL || ''
          axios.post(addRoleURl, data2, { headers, params })
            .then(response => {
              console.log('Response:', response.data);

            })
            .catch(error => {
              console.error('Error:', error);
            });
          // return response.data;
        } catch (error) {
          console.error("Error in POST request:", error);
          throw error;
        }
      }


      return responseHospital.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

// export const updateHospital = createAsyncThunk(
//   "update/hospital",
//   async (data: any | undefined, { rejectWithValue }) => {
//     try {
//       const response = await API.put(
//         `Hospital/hospital/Update/Id?hospitalid=${data?.id}&isSaveAsDraft=${data.isSaveAsDraft}`,
//         data.dispatchData
//       );
//       return response.data;
//     } catch (error: any) {
//       // if (error?.response?.status === 500) {
//       //   window.location.href = routesName.errorPage;
//       // }
//       return rejectWithValue(error);
//     }
//   }
// );
export const updateHospital = createAsyncThunk(
  "update/hospital",
  async (data: any | undefined, { rejectWithValue }) => {
    try {
      console.log(data, 374747)
      const AES_KEY = '2dc41670ehdjurl1jdhu76yhtf6d48bb';
      const AES_IV = '1208987836506021';
      const encryptString = (plainText: string) => {
        const keyUtf8 = CryptoJS.enc.Utf8.parse(AES_KEY || "");
        const ivUtf8 = CryptoJS.enc.Utf8.parse(AES_IV || "");
        const encrypted = CryptoJS.AES.encrypt(plainText, keyUtf8, { iv: ivUtf8 });
        return encrypted.toString();
      };

      const dataResult = {
        email: data?.dispatchData?.hospitalAdminInfo?.email ?? "",
        password: data?.dispatchData.hospitalAdminInfo?.password ? encryptString(data?.dispatchData.hospitalAdminInfo?.password ?? "") : null,
        firstName: data?.dispatchData?.hospitalAdminInfo?.name ?? "",
        lastName: data?.dispatchData?.hospitalAdminInfo?.name?.pop?.() || "-",
        phoneNumber: data?.dispatchData?.hospitalAdminInfo?.phone ?? "",
        IsPasswordChangeOnLogin: data?.dispatchData?.isPasswordChangeOnLogin,
        userId: data?.dispatchData?.hospitalAdminInfo?.userId ?? null,
        accountManagerId: data?.dispatchData?.hospitalInfo?.accountManager?.userId ?? null,
        department: "",
        hospitalid: data?.id,
        degree: "",
        gender: "male",
        ModuleId: 2,
        Roles: [
          'MAHospitalManagement'
        ]


      };
      const token = sessionStorage.getItem('newlogin')
      const url = process.env.REACT_APP_MA_EDIT_HOSPITAL_URL || '';
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`, // Add token here
      };

      const maResponse = data?.dispatchData.hospitalAdminInfo?.password ? await axios.post(url, dataResult, { headers }) : {};
      if (maResponse) {
        const response = await API.put(
          `Hospital/hospital/Update/Id?hospitalid=${data?.id}&isSaveAsDraft=${data.isSaveAsDraft}`,
          data.dispatchData
        );
        return response.data;
      }
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);
// get hospital

export const subscriptionPackageType=async ()=>{
  try{
const response = await API.get("SubscriptionPackage/subscriptionpackages");
return response?.data?.data?.map((item:any)=>({label:item.packagename,value:item.id}));
}catch(error:any){
  console.error("Error in GET request:", error);
  throw error;
}

}


export const getAllHospital = createAsyncThunk(
  "get/allHospital",
  async (
    data: {
      order: string;
      orderBy: string;
      searchQuery?: string;
      page: number;
      rowsPerPage: number;
      searchKeywords: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const decodeToken = await Promise.resolve(AsyncAccessTokenDecoder1());
      const response = await API.get(
        `Hospital/hospitals?order=${data.order}&orderBy=${data.orderBy}${data.searchQuery ?? ""
        }&page=${data.page + 1}&pageSize=${data.rowsPerPage}&searchKeywords=${data?.searchKeywords
        }&userId=${decodeToken?.userId}`
      );
      // return response.data;

      // const hospitals = Array.isArray(response.data)
      //   ? response.data
      //   : response.data?.data ?? [];

      // if (decodeToken?.Roles === "Admin") {
      //   const result = hospitals.filter(
      //     (item: any) =>
      //       item?.hospitalInfo?.accountManager?.userId == decodeToken?.userId
      //   );
      //   console.log(result, "Filtered hospital list");

      //   // ✅ Make sure you return an array (not nested inside an object)
      //   return {
      //     data: result,
      //     error: ""
      //   }
      // }

      const allData = response.data?.data?.map((items: any) => {
        const infraData = items?.infraDetails || {};

        const bedsDictionary = Object.fromEntries(
          (infraData?.beds || []).map((x: any) => [x.subLocationName, x])
        );

        const facilitiesDictionary = Object.fromEntries(
          (infraData?.facilities || []).map((x: any) => [x.facilityName, x])
        );

        return {
          ...items,
          beds: bedsDictionary,
          facilities: facilitiesDictionary,
          equipments: infraData?.equipments || []
        };
      });

      return { ...response.data, data: allData };
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);



// Define the argument type
// type GetAllHospitalArgs = {
//   order: string;
//   orderBy: string;
//   searchQuery?: string;
//   page: number;
//   rowsPerPage: number;
//   searchKeywords: string;
// };

// Define the response type (use any if not known yet)
// type HospitalResponse = any;

// // Optional helper types for decoded tokens
// interface DecodedToken {
//   Roles?: string;
//   [key: string]: any;
// }

// interface UserDetails {
//   userId?: number | string;
//   [key: string]: any;
// }
// export const getAllHospital = createAsyncThunk<
//   HospitalResponse,
//   GetAllHospitalArgs
// >(
//   "get/allHospital",
//   async (data, { rejectWithValue }) => {
//     try {
//       let decodeToken: DecodedToken | null = null;
//       let userDetails: UserDetails | null = null;

//       try {
//         decodeToken = await Promise.resolve(AsyncAccessTokenDecoder1());
//         userDetails = AccessTokenDecoder1();
//       } catch (e) {
//         console.warn("Token decode failed:", e);
//       }

//       console.log("Decoded tokens:", decodeToken, userDetails);

//       if (!decodeToken || !userDetails) {
//         return rejectWithValue("Access token not found or invalid");
//       }

//       const response = await API.get(
//         `Hospital/hospitals?order=${data.order}&orderBy=${data.orderBy}${data.searchQuery ?? ""
//         }&page=${data.page + 1}&pageSize=${data.rowsPerPage}&searchKeywords=${data?.searchKeywords}`
//       );

//       if (decodeToken?.Roles === "Admin") {
//         const result = response.data.filter(
//           (item: any) =>
//             item?.hospitalInfo?.accountManager?.userId === userDetails?.userId
//         );
//         return result;
//       }

//       return response.data;
//     } catch (error: any) {
//       return rejectWithValue(error);
//     }
//   }
// );



export const getHospitalById = createAsyncThunk(
  "get/hospital-by-id",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await API.get(`Hospital/hospital/id?hospitalid=${id}`);
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

// delete hospital
export const deleteHospitalById = createAsyncThunk(
  "delete/hospital-by-id",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await API.delete(
        `Hospital/hospital/delete/id?hospitalid=${id}`
      );
      if (response.data) {
        try {
          const url = process.env.REACT_APP_MA_DEACTIVATE_HOSPITAL_URL || "";
          const token = sessionStorage.getItem("newlogin");

          const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          };

          // IMPORTANT: body must be an object
          const hospitalId = { id };

          const maResponse = await axios.get(url, {
            headers,
            params: { hospitalId }
          });
          console.log("MA API Response:", maResponse.data);
        } catch (err: any) {
          console.error("MA API Error:", err);

        }
      }
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

// get hospital status count
export const getHospitalByStatus = createAsyncThunk(
  "get/hospital-by-status",
  async (
    data: {
      status: string;
      order: string;
      orderBy: string;
      searchQuery?: string;
      page: number;
      rowsPerPage: number;
      searchKeywords: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const decodeToken = await Promise.resolve(AsyncAccessTokenDecoder1());
      const response = await API.get(
        `Hospital/hospitals/Status?status=${data.status}&order=${data.order
        }&orderBy=${data.orderBy}${data.searchQuery ?? ""}&page=${data.page + 1
        }&pageSize=${data.rowsPerPage}&searchKeywords=${data?.searchKeywords}&userId=${decodeToken?.userId}`
      );
      // const hospitals = Array.isArray(response.data)
      //   ? response.data
      //   : response.data?.data ?? [];

      // if (decodeToken?.Roles === "Admin") {
      //   const result = hospitals.filter(
      //     (item: any) =>
      //       item?.hospitalInfo?.accountManager?.userId == decodeToken?.userId
      //   );
      //   console.log(result, "Filtered hospital list");

      //   // ✅ Make sure you return an array (not nested inside an object)
      //   return {
      //     data: result,
      //     error: ""
      //   }
      // }
      const allData = response.data?.data?.map((items: any) => {
        const infraData = items?.infraDetails || {};

        const bedsDictionary = Object.fromEntries(
          (infraData?.beds || []).map((x: any) => [x.subLocationName, x])
        );

        const facilitiesDictionary = Object.fromEntries(
          (infraData?.facilities || []).map((x: any) => [x.facilityName, x])
        );

        return {
          ...items,
          beds: bedsDictionary,
          facilities: facilitiesDictionary,
          equipments: infraData?.equipments || []
        };
      });

      return { ...response.data, data: allData };
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

export const getActiveHosCount = createAsyncThunk(
  "get/active-hos-count",
  async (status: string, { rejectWithValue }) => {
    try {
      const decodeToken = await Promise.resolve(AsyncAccessTokenDecoder1());

      const response = await API.get(
        `Hospital/hospitals/Status/Count?status=${status}&userId=${decodeToken?.userId}`
      );
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);
export const getExpiredHosCount = createAsyncThunk(
  "get/expired-hos-count",
  async (status: string, { rejectWithValue }) => {
    const decodeToken = await Promise.resolve(AsyncAccessTokenDecoder1());

    try {
      const response = await API.get(
        `Hospital/hospitals/Status/Count?status=${status}&userId=${decodeToken?.userId}`
      );
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);
export const getInactiveHosCount = createAsyncThunk(
  "get/inactive-hos-count",
  async (status: string, { rejectWithValue }) => {
    try {
      const decodeToken = await Promise.resolve(AsyncAccessTokenDecoder1());

      const response = await API.get(
        `Hospital/hospitals/Status/Count?status=${status}&userId=${decodeToken?.userId}`
      );
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);
export const getInprogressHosCount = createAsyncThunk(
  "get/inprogress-hos-count",
  async (status: string, { rejectWithValue }) => {
    try {
      const decodeToken = await Promise.resolve(AsyncAccessTokenDecoder1());

      const response = await API.get(
        `Hospital/hospitals/Status/Count?status=${status}&userId=${decodeToken?.userId}`
      );
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

export const getActivePaidCount = createAsyncThunk(
  "get/active-paid-count",
  async (
    data: { status: string; servicetype: string },
    { rejectWithValue }
  ) => {
    try {
      const decodeToken = await Promise.resolve(AsyncAccessTokenDecoder1());

      const response = await API.get(
        `Hospital/hospitals/Status/ServiceType/Count?status=${data.status}&servicetype=${data.servicetype}&userId=${decodeToken?.userId}`
      );
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);
export const getActivePilotCount = createAsyncThunk(
  "get/active-pilot-count",
  async (
    data: { status: string; servicetype: string },
    { rejectWithValue }
  ) => {
    try {
      const decodeToken = await Promise.resolve(AsyncAccessTokenDecoder1());

      const response = await API.get(
        `Hospital/hospitals/Status/ServiceType/Count?status=${data.status}&servicetype=${data.servicetype}&userId=${decodeToken?.userId}`
      );
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

// image upload
export const posthospitalLogo = createAsyncThunk(
  "post/hospital-logo",
  async (data: any | undefined, { rejectWithValue }) => {
    try {
      const response = await API.post(`UploadImage/uploadimage`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

// create hopitalId
export const createHospitalId = createAsyncThunk(
  "create/hospital-id",
  async (data: any | undefined, { rejectWithValue }) => {
    try {
      const response = await API.post(
        `Hospital/hospitals/GenerateHospitalId`,
        data
      );
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

// create user id
export const createHospitalUserId = createAsyncThunk(
  "create/hospital-user-id",
  async (email: string | undefined, { rejectWithValue }) => {
    try {
      const response = await API.post(
        `Hospital/hospitals/GenerateuserId?email=${email}`
      );
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

// get hospital user passowrd
export const getHospitalUserPassword = createAsyncThunk(
  "get/hospital-user-password",
  async (data, { rejectWithValue }) => {
    try {
      const response = await API.get(`Hospital/hospitals/GeneratePassword`);
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

// product activate or deactivate
export const activateOrDeactivateAction = createAsyncThunk(
  "post/hospital-product-activeOrDeactivate",
  async (
    data: { hospitalId: string; productId: number; isactive: number },
    { rejectWithValue }
  ) => {
    try {


      const response = await API.post(
        `Hospital/hospitals/hospitalplan/ActivateOrDeActivate?hospitalid=${data.hospitalId}&productid=${data.productId}&isactive=${data.isactive}`
      );
      // return response.data;
      if (response.data) {
        const url = process.env.REACT_APP_MA_DEACTIVATE_HOSPITAL_URL || '';
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('newlogin')} `, // Add token here
        };
        const hospitalId = data.hospitalId;
        const maResponse = await axios.get(url, {
          headers,
          params: { hospitalId }
        });
        return maResponse.data
      }
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

// de link devices
export const deLinkDeviceAction = createAsyncThunk(
  "post/hospital-device-delink",
  async (
    data: { hospitalId: string; productId: number; deviceId: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.post(
        `Hospital/hospital/DeLinkDevice?hospitalid=${data.hospitalId}&productid=${data.productId}&deviceid=${data.deviceId}`
      );
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

// get account manager list

export const getAccountAllList = createAsyncThunk(
  "get/account-manager-all-list",
  async (data, { rejectWithValue }) => {
    try {
      const response = await API.get("Hospital/hospital/AccountManagerList");
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);


export const resetPasswordHospital = createAsyncThunk(
  "reset/hospital-password",
  async (
    data: {
      email: string | undefined;
      password: string;
      isTempPassword: boolean;

    },
    { rejectWithValue }
  ) => {
    try {
      console.log(data, 374747)
      const AES_KEY = '2dc41670ehdjurl1jdhu76yhtf6d48bb';
      const AES_IV = '1208987836506021';
      const encryptString = (plainText: string) => {
        const keyUtf8 = CryptoJS.enc.Utf8.parse(AES_KEY || "");
        const ivUtf8 = CryptoJS.enc.Utf8.parse(AES_IV || "");
        const encrypted = CryptoJS.AES.encrypt(plainText, keyUtf8, { iv: ivUtf8 });
        return encrypted.toString();
      };

      const resultData = {
        Email: data?.email ?? "",
        NewPassword: data?.password ? encryptString(data?.password ?? "") : null,


        IsPasswordChangeOnLogin: data?.isTempPassword,
      }

      // const Email = data.email;
      // const NewPassword = data.password ? encryptString(data.password as any || "") : null;
      const url = process.env.REACT_APP_MA_RESET_PASSWORD_URL || '';
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('newlogin')} `, // Add token here
      };

      const maResponse = await axios.post(url, resultData, { headers });

      return maResponse.data
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);